import React, { ReactNode, useContext } from 'react';
import { AppContext } from '../../../common/context/Provider';

interface Props {
    isOpen: boolean;
    modalTitle: string;
    isLoading: boolean;
    isShowControls: boolean;
    children: ReactNode;
    textButton?: string;
    onSubmit: () => void;
    onClose: () => void;
    customMaxWidth?: number;
    disableSubmit?: boolean;
}

export const BaseConfirmModal = ({
    isOpen,
    modalTitle,
    onSubmit,
    onClose,
    children,
    isLoading,
    isShowControls,
    textButton = 'Aceptar',
    disableSubmit,
    customMaxWidth = 700,
}: Props) => {
    const { langResources, isSkinSmart } = useContext(AppContext);

    return (
        <div
            className='modal'
            aria-hidden='true'
            style={{
                display: isOpen ? 'block' : 'none',
                background: 'rgba(0,0,0,0.5)',
                zIndex: 99999,
            }}
        >
            <div
                id='modal-confirm'
                className='modal-dialog rounded w-100 '
                style={{ maxWidth: customMaxWidth }}
            >
                <div className='modal-content'>
                    <div className='modal-header'>
                        <div className='modal-header d-flex justify-content-between w-100 '>
                            <h5 className={`modal-title text-primary2`}>
                                {modalTitle}
                            </h5>
                            <button
                                type='button'
                                className='btn-close'
                                data-bs-dismiss='modal'
                                aria-label='Close'
                                onClick={onClose}
                            ></button>
                        </div>
                    </div>

                    <div className='modal-body text-dark'>
                        {!isLoading ? (
                            <div>{children}</div>
                        ) : (
                            <div>
                                <h5 className='card-title placeholder-glow'>
                                    <span className='placeholder col-6'></span>
                                </h5>
                                <p className='card-text placeholder-glow mb-5'>
                                    <span className='placeholder col-7 bg-dark'></span>
                                    <span className='placeholder col-4 bg-dark'></span>
                                    <span className='placeholder col-4 bg-dark'></span>
                                </p>
                                <p className='card-text placeholder-glow'>
                                    <span className='placeholder col-7 bg-dark'></span>
                                    <span className='placeholder col-4 bg-dark'></span>
                                    <span className='placeholder col-4 bg-dark'></span>
                                </p>
                                <p className='card-text placeholder-glow'>
                                    <span className='placeholder col-7 bg-dark'></span>
                                    <span className='placeholder col-4 bg-dark'></span>
                                    <span className='placeholder col-4 bg-dark'></span>
                                </p>
                                <p className='card-text placeholder-glow mb-3'>
                                    <span className='placeholder col-6 bg-dark'></span>
                                    <span className='placeholder col-6 bg-dark'></span>
                                </p>
                            </div>
                        )}
                    </div>

                    {isShowControls && (
                        <div className='modal-footer justify-content-center'>
                            <button
                                type='button'
                                className='btn btn-light'
                                onClick={onClose}
                                data-bs-dismiss='modal'
                            >
                                {langResources['basemoda.cancel.button']}
                            </button>
                            <button
                                type='button'
                                className={`btn btn-primary`}
                                onClick={onSubmit}
                                disabled={disableSubmit}
                            >
                                {textButton}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
